var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Icon from "./Icon";
import React from 'react';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import { space } from 'styled-system';
import { css, styled } from "../utils";
var StyledInfoIcon = styled(Icon.OpenHint)(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    cursor: pointer;\n    vertical-align: middle;\n\n    path {\n      fill: ", ";\n    }\n\n    .darken,\n    &:hover {\n      filter: brightness(80%);\n      -webkit-filter: brightness(80%);\n    }\n  "], ["\n    cursor: pointer;\n    vertical-align: middle;\n\n    path {\n      fill: ", ";\n    }\n\n    .darken,\n    &:hover {\n      filter: brightness(80%);\n      -webkit-filter: brightness(80%);\n    }\n  "])), colors.secondary);
});
var Content = styled.div(function (_a) {
    var _b = _a.theme, fonts = _b.fonts, fontWeights = _b.fontWeights, fontSizes = _b.fontSizes;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-family: ", ";\n    letter-spacing: 0.82px;\n    text-align: center;\n    line-height: normal;\n    font-size: ", ";\n    font-weight: ", ";\n  "], ["\n    font-family: ", ";\n    letter-spacing: 0.82px;\n    text-align: center;\n    line-height: normal;\n    font-size: ", ";\n    font-weight: ", ";\n  "])), fonts.primary, fontSizes.normal, fontWeights.medium);
});
var Container = styled.div(space);
var Hint = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.colorTheme, colorTheme = _b === void 0 ? 'dark' : _b, icon = _a.icon, props = __rest(_a, ["children", "className", "colorTheme", "icon"]);
    return (React.createElement(Container, __assign({}, props),
        React.createElement(Tooltip, { position: "top", arrow: true, useContext: true, trigger: "mouseenter", size: "big", theme: colorTheme, html: React.createElement(Content, null, children) },
            React.createElement("div", null, icon || React.createElement(StyledInfoIcon, { className: className })))));
};
export var RadioHint = function (_a) {
    var children = _a.children;
    return React.createElement(Hint, { colorTheme: "light" }, children);
};
export default Hint;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Hint.js.map